import { render } from "./CreateCategoryPage.vue?vue&type=template&id=c3f3ae48"
import script from "./CreateCategoryPage.vue?vue&type=script&lang=js"
export * from "./CreateCategoryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__